<div class="split-container">
    <div class="value ellipsis">
      <span *ngIf="report.CHARGE_DESC && report.CHARGE_DESC.length > 0" class="sigma"><fa name="fa fa-commenting"></fa></span>
      {{currencyPipe.transform(report.CHARGE)}}
    </div>
    <template #target></template>
</div>
